import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Card,
  Input,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Modal,
  ModalBody,
  Progress,
  Table,
  ButtonGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import NotificationAlert from 'react-notification-alert';
import PackageDialog from './PackageDialog';
import { db } from '../../MY_LOGIN_AND_SIGNUP/db/config';
import { Edit, Delete } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
// import { makeStyles } from '@mui/material';

import PackageDelete from './PackageDelete';
import SelectedPackageDelete from './SelectedPackageDelete';
import { algoliaAppID, algoliaSearchID } from '../../Utilities/algoliaKeys';
import algoliasearch from 'algoliasearch/lite';
import SearchIcon from '@mui/icons-material/Search';

// const useStyles = makeStyles((theme) => ({
//   appBar: {
//     position: 'relative',
//   },
//   title: {
//     marginLeft: theme.spacing(2),
//     flex: 1,
//   },
// }));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

function PackageManagement() {
  const notification = useRef();
  const [progressVisible, setProgressVisible] = useState(true);
  const [progressValue, setProgressValue] = useState(8);
  const [open, setOpen] = useState(false);
  const [packageData, setPackageData] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [currentPackage, setcurrentPackage] = useState('');
  const [allChecked, setAllChecked] = useState(false);
  const [isAllDeleteModalVisible, setIsAllDeleteModalVisible] = useState(false);
  const [selected, setSelected] = useState(false);
  const [selectedArr, setSelectedArr] = useState([]);
  const [packageSearchValue, setPackageSearchValue] = useState('');
  const searchClient = algoliasearch(algoliaAppID, algoliaSearchID);
  const packageSearchIndex = searchClient.initIndex('Package_Search');

  const notify = (msg, err) => {
    let color = err === true ? 'danger' : 'success';
    let options = {
      type: color,
      place: 'tr',
      message: (
        <div>
          <div>
            <b>{err === true ? 'Error' : 'Success'}</b> - {msg}.
          </div>
        </div>
      ),
      icon: 'tim-icons icon-bell-55',
      autoDismiss: 6,
    };
    if (notification.current) {
      notification.current.notificationAlert(options);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getPackagelist = () => {
    document.querySelector('#loading-indicator').style.display = 'flex';
    db.collection('zSystemStore')
      .where('type', '==', 'package')
      .get()
      .then((querySnapshot) => {
        let data = querySnapshot.docs.map((doc) => doc.data());
        // console.log('packageData:',data)
        data = data.map((item) => {
          return { ...item, select: false };
        });
        setPackageData(data);
        setProgressVisible(false);
        document.querySelector('#loading-indicator').style.display = 'none';
      });
  };

  useEffect(() => {
    setProgressValue(99);
    getPackagelist();
  }, []);

  const deletePackage = (data) => {
    const afterDelete = packageData.filter((item) => item.itemID !== data);
    setPackageData(afterDelete);

    db.collection('zSystemStore')
      .doc(data)
      .delete()
      .then(() => {
        console.log('record deleted ');
        notify('Package deleted successfully', false);
      })
      .catch((error) => {
        notify(error.toString(), true);

        console.log('this is error ', error);
      });
  };

  const deleteSelected = () => {
    console.log('ye chala');
    let selectedId = [];
    packageData.map((item) => {
      if (item.select && item.itemID != undefined) {
        selectedId.push(item.itemID);
      }
    });

    let batch = db.batch();
    for (let i = 0; i < selectedId.length; i++) {
      batch.delete(db.collection('zSystemStore').doc(selectedId[i]));
    }

    batch
      .commit()
      .then(() => {
        setPackageData((prev) =>
          prev.filter((item) => !selectedId.includes(item.itemID))
        );
        setIsAllDeleteModalVisible(false);
      })
      .catch((err) => {
        console.log(err);
      });
    console.log('id:', selectedId);
  };

  const packageSearch = () => {
    if (packageSearchValue == '') {
      notify('Search field can not be empty', true);
    } else {
      document.querySelector('#loading-indicator').style.display = 'flex';

      packageSearchIndex
        .search(packageSearchValue, { typoTolerance: false })
        .then((result) => {
          if (result.hits.length === 0) {
            document.querySelector('#loading-indicator').style.display = 'none';

            notify('No results found', true);
          } else {
            document.querySelector('#loading-indicator').style.display = 'none';

            setPackageData(result.hits);
            // setReload(true);
          }
        })
        .catch((err) => {
          if (document.querySelector('#loading-indicator') !== null)
            document.querySelector('#loading-indicator').style.display = 'none';
          notify(err.toString(), true);
        });
    }
  };

  const emptyCall = () => {
    getPackagelist();
  };

  return (
    <>
      {progressVisible ? (
        <Progress color='info' value={progressValue} style={{ height: 4 }} />
      ) : (
        <div className='content'>
          <div className='react-notification-alert-container'>
            <NotificationAlert ref={notification} />
          </div>
          <Modal
            isOpen={deleteModal}
            color='primary'
            style={{
              display: 'flex',
              flex: 1,
              top: -40,
              width: 250,
              backgroundColor: '#132639',
              objectFit: 'fill',
            }}
          >
            <ModalBody style={{ width: '100%' }} size='sm'>
              <PackageDelete
                deletePackage={() => deletePackage(currentPackage)}
                setDeleteModal={setDeleteModal}
              ></PackageDelete>
            </ModalBody>
          </Modal>
          <Modal
            isOpen={isAllDeleteModalVisible}
            color='primary'
            style={{
              display: 'flex',
              flex: 1,
              top: -40,
              width: 350,
              backgroundColor: '#132639',
              objectFit: 'fill',
            }}
          >
            <ModalBody size='sm' style={{ textAlign: 'center' }}>
              <SelectedPackageDelete
                setIsAllDeleteModalVisible={setIsAllDeleteModalVisible}
                deleteSelected={deleteSelected}
              />
            </ModalBody>
          </Modal>
          <Dialog
            fullScreen
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
          >
            <PackageDialog
              currentPackage={currentPackage}
              setPackageData={setPackageData}
              notifi={notify}
              handleClose={handleClose}
            />
          </Dialog>
          <Row>
            <Col md='12'>
              <Card>
                <CardHeader>
                  <Row>
                    <Col sm={9} style={{ textAlign: 'center' }}>
                      <CardTitle
                        tag='h4'
                        style={{ fontWeight: 300, textAlign: 'left' }}
                      >
                        PACKAGE MANAGEMENT
                      </CardTitle>
                    </Col>
                    <Col sm={2}>
                      <Button
                        color='info'
                        style={{ float: 'right' }}
                        onClick={() => {
                          // setCurrentQuiz('')
                          setcurrentPackage('');
                          handleClickOpen();
                        }}
                      >
                        Add Package
                      </Button>
                    </Col>
                    {selected || selectedArr.length > 0 ? (
                      <Col sm={1} style={{ marginTop: 5 }}>
                        <Button
                          style={{ margin: '0px', padding: '6px 10px' }}
                          color='danger'
                          onClick={() => setIsAllDeleteModalVisible(true)}
                        >
                          <Delete />
                        </Button>
                      </Col>
                    ) : null}
                  </Row>
                  <Row>
                    <Col sm={4}>
                      <Input
                        type='text'
                        name='searchInvoice'
                        placeholder='Search Package'
                        onInput={(e) => {
                          setPackageSearchValue(e.target.value);
                          e.target.value.length === 0 && emptyCall();
                        }}
                      />
                    </Col>
                    <Col style={{ paddingLeft: '0px' }} sm={2}>
                      <Button
                        style={{ margin: '0px', padding: '6px 10px' }}
                        color='info'
                        onClick={packageSearch}
                      >
                        <SearchIcon />
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>

                <CardBody>
                  <Table className='tablesorter'>
                    <thead className='text-primary'>
                      <tr>
                        <th>
                          <input
                            type='checkbox'
                            checked={allChecked}
                            onChange={(e) => {
                              let checked = e.target.checked;
                              if (checked == true) {
                                setSelected(true);
                              } else {
                                setSelected(false);
                                setSelectedArr([]);
                              }
                              let checkedData = packageData.map((data) => {
                                data.select = checked;
                                return data;
                              });
                              setAllChecked(checked);
                              setPackageData(checkedData);
                            }}
                          />
                        </th>
                        <th>Package Title</th>
                        <th style={{ textAlign: 'center' }}>Book Count</th>
                        <th style={{ textAlign: 'center' }}>Mock Count</th>
                        <th style={{ textAlign: 'center' }}>Question Count</th>
                        <th style={{ textAlign: 'center' }}>With Classes</th>
                        <th style={{ textAlign: 'center' }}>Price</th>
                        <th style={{ textAlign: 'center' }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {packageData.map((item) => {
                        // let status = user.status && [];
                        // console.log('packageData:', item);
                        return (
                          <tr key={item.itemID}>
                            <td>
                              <input
                                type='checkbox'
                                checked={item.select}
                                onChange={(e) => {
                                  let checked = e.target.checked;
                                  setPackageData(
                                    packageData.map((data) => {
                                      if (item.itemID === data.itemID) {
                                        data.select = checked;
                                        if (checked) {
                                          setSelectedArr((prev) => [
                                            { id: item.itemID },
                                            ...prev,
                                          ]);
                                        } else {
                                          setSelectedArr((prev) =>
                                            prev.filter(
                                              (dataId) =>
                                                dataId.id !== item.itemID
                                            )
                                          );
                                        }
                                      }
                                      if (e.target.checked == false) {
                                        setAllChecked(false);
                                      }
                                      return data;
                                    })
                                  );
                                }}
                              />
                            </td>
                            <td>{item.title}</td>
                            <td style={{ textAlign: 'center' }}>
                              {item.numberOfBook}
                            </td>
                            <td style={{ textAlign: 'center' }}>
                              {item.numberOfQuiz}
                            </td>
                            <td style={{ textAlign: 'center' }}>
                              {item.numberOfQuestions}
                            </td>
                            <td style={{ textAlign: 'center' }}>
                              {item.withClasses ? (
                                <CheckCircleIcon
                                  style={{ fontSize: '35px', color: '#17de3e' }}
                                />
                              ) : (
                                <CancelIcon
                                  style={{ fontSize: '35px', color: '#f51d1d' }}
                                />
                              )}
                            </td>
                            <td
                              style={{
                                fontFamily: 'Roboto, sans-serif',
                                textAlign: 'center',
                              }}
                            >
                              ₹ {item.price}
                            </td>

                            <td style={{ textAlign: 'center' }}>
                              <Edit
                                style={{ color: '#247cf7', cursor: 'pointer' }}
                                onClick={() => {
                                  setcurrentPackage(item);
                                  handleClickOpen();
                                }}
                              />
                              <Delete
                                onClick={() => {
                                  setcurrentPackage(item.itemID);
                                  setDeleteModal(true);
                                }}
                                style={{ color: 'red', cursor: 'pointer' }}
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* <Modal isOpen={editModal} style={{ display: 'flex', flex: 1, top: -200, minWidth:'85%' }} >
                <ModalBody className={styles.create__quiz_modal_body} >
                    <QuizEditModal notify={notify}
                        setquizData={setquizData} currentQuestion={currentQuestion} onClick={() => {
                            setEditModal(false)
                        }}>

                    </QuizEditModal>
                </ModalBody>
            </Modal> */}
        </div>
      )}
    </>
  );
}

export default PackageManagement;
